import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Shop from "../pages/shop/page";
import Lookbook from "../pages/lookbook/page";
import FAQ from "../pages/faq/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news/detail";
import Blog from "../pages/blog/page";
import BlogDetail from "../pages/blog/detail";
import Product from "../pages/product/page";
import Appointment from "../pages/appointment/page";
import Reviews from "../pages/reviews/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/shop", element: <Shop /> },
  { path: "/product/:id", element: <Product /> },
  { path: "/lookbook", element: <Lookbook /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/contact", element: <Contact /> },
  { path: "/news", element: <News /> },
  { path: "/news/:id", element: <NewsDetail /> },
  { path: "/blog", element: <Blog /> },
  { path: "/blog/:id", element: <BlogDetail /> },
  { path: "/appointment", element: <Appointment /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
